/**
 * Import Dependency
 */
import { handleActions } from 'redux-actions'
import update from 'immutability-helper'

/**
 * Declare Variable
 */
const defaultUserState = {
  refresh: '',
  token: '',
  permissions: [],
  tel: '',
  name: '',
  deliveryAddress: '',
  address: '',
  floorRoom: '',
  companyBuilding: '',
  district: '',
  lat: null,
  lng: null,
  needTableware: false,
  code: '',
}

/**
 * Export
 */
export const user = handleActions({
  REGISTER_USER: (state, action) => {
    return update(state, {
      refresh: { $set: action.payload.refresh },
      token: { $set: action.payload.token },
      permissions: { $set: action.payload.permissions || [] },
    })
  },
  UPDATE_USER: (state, action) => {
    return update(state, {
      refresh: { $set: action.payload.refresh },
      token: { $set: action.payload.token },
      permissions: { $set: action.payload.permissions || [] },
    })
  },
  UPDATE_USER_ID: (state, action) => {
    return update(state, {
      id: { $set: action.payload },
    })
  },
  UPDATE_TEL: (state, action) => {
    return update(state, {
      tel: { $set: action.payload },
    })
  },
  UPDATE_NAME: (state, action) => {
    return update(state, {
      name: { $set: action.payload },
    })
  },

  UPDATE_DELIVERY_ADDRESS: (state, action) => {
    return update(state, {
      deliveryAddress: { $set: action.payload },
    })
  },
  UPDATE_ADDRESS: (state, action) => {
    return update(state, {
      address: { $set: action.payload },
    })
  },
  UPDATE_FLOOR_ROOM: (state, action) => {
    return update(state, {
      floorRoom: { $set: action.payload },
    })
  },
  UPDATE_COMPANY_BUILDING: (state, action) => {
    return update(state, {
      companyBuilding: { $set: action.payload },
    })
  },
  UPDATE_DISTRICT: (state, action) => {
    return update(state, {
      district: { $set: action.payload },
    })
  },
  UPDATE_LAT: (state, action) => {
    return update(state, {
      lat: { $set: action.payload },
    })
  },
  UPDATE_LNG: (state, action) => {
    return update(state, {
      lng: { $set: action.payload },
    })
  },
  UPDATE_NEED_TABLEWARE: (state, action) => {
    return update(state, {
      needTableware: { $set: action.payload },
    })
  },
  UPDATE_PASSCODE: (state, action) => {
    return update(state, {
      code: { $set: action.payload },
    })
  },
}, defaultUserState)

export default {
  user,
}



// WEBPACK FOOTER //
// ./src/reducers/components/user.js